// External
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import Moment from 'moment';
import { cloneDeep, debounce, isNull } from 'lodash';
import { withRouter } from '../../utils/withRouter';

// Internal
import DraggableSiteRouteCrew from '../cards/DraggableSiteRouteCrew';
import DraggableShiftCanvasser from '../cards/DraggableShiftCanvasser';
import FilterDisplay from '../subscreens/FilterDisplay';
import { filterAndSortItems, handleSearchChange } from '../../utils/FilterDisplayUtils';
import { findCanvassersAssignedToShift, findCheckedInCanvassers } from '../../utils/schedulerUtils';

import api from '../../store/api/api';
import {
  createCrew,
  createCrewCanvasser,
  createShift,
  createShiftCanvasser,
  deleteCrew,
  deleteCrewCanvasser,
  getSchedule,
  pullCampaignCanvassers,
  pullCrews,
  pullSiteRoutes,
  updateCrew,
  updateShiftCanvasser,
} from '../../store/api/calls';

import { setCrews, setCrewsShiftData, setSessionVar } from '../../store/actions';

import NavBaseTemplate from '../templates/NavBaseTemplate';
import FeedbackTile from '../theme/modals/FeedbackTile';
import Tabs from '../theme/menus/Tabs';
import Input from '../theme/forms/Input';
import BaseModal from '../theme/modals/BaseModal';
import SiteNoteModal from '../theme/modals/SiteNoteModal';
import CanvasserFilters from '../subscreens/CanvasserFilters';

class Schedule extends Component {
  crewRefs = {};

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      pageError: false,
      errMsg: 'There was a server error',
      siteRoutes: [],
      crews: [],
      crewsDrop: [],
      displayedCanvassers: [],
      selectedDate: new Moment(Date.now()).format('YYYY-MM-DD'),
      sideBarSelection: 'siteroutes',
      showAssignedCanvassers: true,
      hideSitesInRoutes: false,
      crewDropMatActive: false,
      availableCanvasserStatuses: ['checked_in', 'not_checked_in', 'unscheduled'],
      displayedCanvasserStatuses: ['checked_in', 'not_checked_in', 'unscheduled'],
      displayedCanvasserAbilities: this.flattenAbilities(),

      // crewsheets
      crewsheet_modal_show: false,
      crewsheet_crews: [],
      crewsheet_get_dirs: true,
      crewsheet_selected_shift_idx: 0,

      // shifts
      shiftData: [],
      shiftId: 0,
      showShiftModal: false,
      shiftStart: undefined,
      shiftEnd: undefined,
      invalidInput: false,
      invalidTime: false,
      shiftError: false,
      lockShiftSubmit: false,

      canvasserFilters: {
        id: 'canvassers',
        keyword: '',
        keywordPersist: '',
        noteTags: [],
        sortBy: 'lastname',
        sortDsc: false,
        searchFields: ['firstname', 'lastname', 'created_at'],
        sortFields: [
          { display: 'Name', value: 'lastname' },
          { display: 'Creation Date', value: 'created_at' },
          { display: 'Status', value: 'status' },
        ],
      },

      routeFilters: {
        id: 'routes',
        keyword: '',
        keywordPersist: '',
        noteTags: [],
        sortBy: 'siteroute_name',
        sortDsc: false,
        searchFields: ['siteroute_name'],
        sortFields: [
          { display: 'Name', value: 'siteroute_name' },
          { display: 'Creation Date', value: 'created_at' },
          { display: 'Seat Count', value: 'seat_count' },
        ],
      },

      focusedOffice: 0,
    };

    this.focusedSiteCanvass = 0;

    this.colorClassMapping = {
      checked_in: { class: '_green', color: '#33a02c' },
      not_checked_in: { class: '_red', color: '#e31a1c' },
      unscheduled: { class: '_grey', color: 'darkgrey' },
      assigned: { class: '_blue', color: '#1f78b4' },
    };

    this.dateChangeTimeout = undefined;
  }

  componentDidMount() {
    this.setState({ displayedCanvasserAbilities: this.flattenAbilities() });

    if (this.props.focusedCampaign !== 0 && !this.props.focusedCampaign.id) {
      setTimeout(() => this.componentDidMount(), 200);
    } else {
      this.getDataOnLoad();
    }
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props.canvassers) !== JSON.stringify(prevProps.canvassers)) {
      this.setState({ displayedCanvasserAbilities: this.flattenAbilities() });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.dateChangeTimeout);
  }

  setError = (errMsg) => {
    this.setState({ errMsg, pageError: true });
    setTimeout(() => this.setState({ pageError: false }), 3000);
  };

  getAndParseSchedule = () => {
    return getSchedule(this.state.focusedOffice, this.state.selectedDate).then((data) => {
      let scs = [];
      let scsIds = [];

      data.forEach((d) => {
        d.canvassers.forEach((shift_canvasser) => {
          let c = this.props.canvassers.find((item) => item.id === shift_canvasser.canvasser);
          if (c && !scsIds.includes(c.id)) {
            c.shift = shift_canvasser.shift;
            c.present = shift_canvasser.present;
            c.assigned = !isNull(shift_canvasser.crew);
            c.scheduled = shift_canvasser.scheduled;
            scs.push(c);
            scsIds.push(c.id);
          }
        });
      });

      let scheduled_ids = scs.length ? scs.map((_d) => _d.id) : [];
      let final = [...scs, ...this.props.canvassers.filter((c) => !scheduled_ids.includes(c.id))];

      final = final.map(this.setShiftCanvasserStatus);
      final = final.filter((n) => n.office == this.state.focusedOffice);

      let shiftId = data[this.state.crewsheet_selected_shift_idx]
        ? data[this.state.crewsheet_selected_shift_idx].id
        : 0;

      this.setState({ displayedCanvassers: final, shiftData: data, shiftId });
    });
  };

  setShiftCanvasserStatus = (d) => {
    if (d.scheduled && d.present) {
      d.status = 'checked_in';
    } else if (d.scheduled && !d.present) {
      d.status = 'not_checked_in';
    } else {
      d.status = 'unscheduled';
    }

    let crewmembers = this.state.crews.reduce((acc, item) => {
      let members = item.routeseats.filter((s) => !!s.canvasser_id).map((s) => s.canvasser_id);
      return [...acc, ...members];
    }, []);

    if (crewmembers.includes(d.id)) d.assigned = true;
    return d;
  };

  getDataOnLoad() {
    this.setState({ loading: true });
    const { params } = this.props;

    this.focusedSiteCanvass = params.sitecanvass_id || 0;
    let fullSiteCanvass = this.props.siteCanvasses.find((d) => d.id === this.focusedSiteCanvass);
    if (fullSiteCanvass) this.state.focusedOffice = fullSiteCanvass.office;

    // Site canvass id will come from url params
    new Promise((resolve, reject) => {
      if (this.state.focusedOffice) {
        resolve();
      } else {
        return api
          .get(`/sitecanvasses/${this.focusedSiteCanvass}/`)
          .then((res) => {
            this.setState({
              focusedOffice: +res.data.office,
            });
            return resolve();
          })
          .catch((err) => {
            console.error(err);
            this.setState({
              pageError: true,
              errMsg: 'Error loading Site Canvass Data',
              loading: false,
            });

            this.setState({ focusedOffice: 0 });
            return reject();
          });
      }
    })
      .then(() => {
        Promise.all([
          pullSiteRoutes(this.focusedSiteCanvass),
          pullCampaignCanvassers({
            abilities: 1,
          }),
          pullCrews({
            sitecanvass: params.sitecanvass_id,
            date: this.state.selectedDate,
          }),
        ])
          .then((data) => {
            return this.getAndParseSchedule().then((res) => {
              let crews = data[2] || [];
              let formed_crews = [];
              const { siteRoutes } = { ...this.props };

              let siteroutes = siteRoutes.map((item) => {
                return { ...item, routeseats: [...item.routeseats] };
              });

              this.setState({ siteRoutes: siteroutes });

              if (crews) {
                crews.forEach((crew) => {
                  let found_sr = siteRoutes.find(
                    (d) => d.siteroute_id === crew.siteroute && !crew.crew_id
                  );
                  if (found_sr) {
                    found_sr = cloneDeep(found_sr);
                    found_sr.crew_id = crew.id;
                    found_sr = { ...crew, ...found_sr };

                    found_sr.routeseats.forEach((rs) => {
                      crew.canvassers.forEach((c) => {
                        if (rs.routeseat_id === c.routeseat_id) {
                          let { crewcanvasser_id, canvasser_id, goal, comments, roles } = c;
                          rs.crewcanvasser_id = crewcanvasser_id;
                          rs.canvasser_id = canvasser_id;
                          rs.goal = goal;
                          rs.comments = comments;
                          rs.roles = roles || [];
                        }
                      });

                      rs.assignment_placeholder_note = (
                        crew.assignment_notes.find(
                          (d) => d.shift === crew.shift && d.routeseat === rs.routeseat_id
                        ) || {}
                      ).note;
                    });

                    formed_crews.push(found_sr);
                  }
                });
              }

              const deepclone_crew = cloneDeep(formed_crews);
              this.setState({
                siteRoutes,
                crews: deepclone_crew,
                loading: false,
              });
            });
          })
          .then(() => {
            if (this.state.shiftData.length) {
              this.props.setCrewsShiftData(this.state.shiftData[0]);
            }
          })
          .catch((err) => {
            this.setState({
              loading: false,
              pageError: true,
              errMsg: 'Error retrieving crew data.',
            });
          });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loading: false, pageError: true });
      });
  }

  // DRAG END HANDLER
  onDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    document.getElementById('crew-drop-mat').className = 'crew-drop-mat';
    document.getElementById('crewlist').className = 'crewlist';

    if (
      !destination ||
      (destination.droppableId === source.droppableId && destination.index === source.index) ||
      this.state.shiftData.length === 0
    ) {
      this.setState({ crewDropMatActive: false });
      return;
    }

    const drop_is_seat_assignment = destination.droppableId.includes('routeseat-assign');

    const start = this.state[source.droppableId];

    let endId;
    if (destination.droppableId === 'crewsDrop' || drop_is_seat_assignment) {
      endId = 'crews';
    } else {
      endId = destination.droppableId;
    }

    let end = this.state[endId];

    if (start === end) {
      const newColumnIds = Array.from(start);
      let spliced = newColumnIds.splice(source.index, 1);
      if (spliced.length > 0) {
        newColumnIds.splice(destination.index, 0, spliced[0]);
      }

      const newState = {
        ...this.state,
        crewDropMatActive: false,
        [destination.droppableId]: newColumnIds,
      };

      this.setState(newState);
      return;
    }

    if (drop_is_seat_assignment) {
      if (destination.droppableId === 'crewsDrop') return;

      let target_canvasser_id = draggableId.split('_')[1];
      let target_seat_id = destination.droppableId.match(/routeseat-assign_(\d+)/)[1];
      let target_crew_id = destination.droppableId.match(/_crew_(\d+)/)[1];

      this._handleCanvasserSelect(target_crew_id, target_seat_id, target_canvasser_id);
      return;
    }

    const newStart = Array.from(start);
    const newFinish = Array.from(end);

    let item = newStart.find((d) => d.siteroute_id === +draggableId);

    if (item) {
      newFinish.splice(destination.index, 0, cloneDeep(item));
    }

    const newState = {
      ...this.state,
      crewDropMatActive: false,
      [source.droppableId]: start,
      [endId]: newFinish,
    };

    if (source.droppableId === 'siteRoutes') {
      if (!this.state.shiftId) return;

      let requestData = {
        siteroute: item.siteroute_id,
        canvass_date: this.state.selectedDate,
        shift: this.state.shiftId,
      };

      this.setState({ loading: true });
      createCrew(requestData).then((crew) => {
        newState.crews.forEach((d) => {
          if (d.siteroute_id === crew.siteroute && !d.crew_id) {
            d.shift = crew.shift;
            d.crew_id = crew.id;
          }
        });
        newState.loading = false;
        this.setState(newState);
      });
    } else {
      this.setState(newState);
    }
  };

  updateOrCreateShiftCanvasser(canvasser_id, crew_id) {
    let exists = false;

    this.state.displayedCanvassers.length &&
      this.state.displayedCanvassers.forEach((canvasser) => {
        if (canvasser.id === +canvasser_id && canvasser.shift) {
          exists = true;
        }
      });

    const updateState = (shiftCanvData) => {
      let newCanvList = [...this.state.displayedCanvassers];
      newCanvList.forEach((d) => {
        if (d.id === +shiftCanvData.canvasser && d.shift === +shiftCanvData.shift) {
          d.assigned = !isNull(shiftCanvData.crew);
        }
      });
      this.setState({ displayedCanvassers: newCanvList });
    };

    if (exists) {
      updateShiftCanvasser({
        canvasser: canvasser_id,
        shift: this.state.shiftId,
        crew: crew_id,
      }).then(updateState);
    } else {
      createShiftCanvasser({
        canvasser: canvasser_id,
        shift: this.state.shiftId,
        crew: crew_id,
        scheduled: false,
        present: false,
      }).then(updateState);
    }
  }

  _handleCanvasserSelect = async (
      crew_id,
      routeseat_id,
      canvasser_id,
      crewcanvasser_id,
      _delete = false
  ) => {
    const crewcanvassers_to_delete = [];

    const update_cols = (data) => {
      const crews = cloneDeep(this.state.crews);
      const siteRoutes = cloneDeep(this.props.siteRoutes);

      crews.forEach((c) => {
        if (+c.crew_id !== +data.crew) return;

        c.routeseats = c.routeseats.map((d) => {
          // Target seat
          if (+d.routeseat_id === +routeseat_id) {
            if (d.crewcanvasser_id) {
              crewcanvassers_to_delete.push(d.crewcanvasser_id);
            }

            return {
              ...d,
              canvasser_id: data.canvasser,
              crewcanvasser_id: data.id,
              goal: data.goal || null,
              comments: data.comments || null,
              roles: [],
            };
          }
          // Same canvasser assigned elsewhere → unassign
          if (+d.canvasser_id === +canvasser_id) {
            crewcanvassers_to_delete.push(d.crewcanvasser_id);

            return {
              ...d,
              canvasser_id: null,
              crewcanvasser_id: null,
              goal: null,
              comments: null,
              roles: [],
            };
          }

          return d;
        });
      });

      this.setState({ crews, siteRoutes });
    };

    this.setState({ loading: true });

    try {
      if (!_delete) {
        // ASSIGN
        const data = await createCrewCanvasser({
          crew: crew_id,
          routeseat: routeseat_id,
          canvasser: canvasser_id,
        });

        update_cols(data);

        if (crewcanvassers_to_delete.length) {
          crewcanvassers_to_delete.forEach((id) => deleteCrewCanvasser(id));
        }

        await this.updateOrCreateShiftCanvasser(canvasser_id, crew_id);
      } else {
        // UNASSIGN
        if (!crewcanvasser_id) return;

        try {
          await deleteCrewCanvasser(crewcanvasser_id);

          // Only proceed with UI update if delete was successful
          await this.updateOrCreateShiftCanvasser(canvasser_id, null);

          update_cols({
            crew: crew_id,
            routeseat_id,
            canvasser: null,
            id: null,
          });
        } catch (error) {
          console.error("Failed to unassign canvasser:", error);
          const errorMessage = error.response?.data?.errors ||
              error.response?.data?.reason ||
              "An unknown error occurred";

          alert(errorMessage);

        }
      }
    } finally {
      this.setState({ loading: false });

      // Refresh Uber rides for this crew
      const crewRef = this.crewRefs?.[crew_id];
      if (crewRef?.refreshUberRides) {
        crewRef.refreshUberRides();
      }
    }
  };

  _handleDeleteCrew = (id) => {
    this.setState({ loading: true });
    deleteCrew(id).then(() => {
      this.setState({
        crews: this.state.crews.filter((d) => d.crew_id !== id),
        loading: false,
      });
    });
  };

  _handleFilterTextChange = (val) => {
    this.setState({
      persistFilterValue: '',
      filterText: val.trim().toLowerCase(),
    });
  };

  buildRoutesToDisplay() {
    return filterAndSortItems(this.state.siteRoutes, this.state.routeFilters);
  }

  _renderUnassignedRoutes(finalList) {
    return (
      <Droppable
        droppableId="siteRoutes"
        style={{ minHeight: '100px', minWidth: '10rem', width: '100%' }}
      >
        {(provided) => (
          <div
            ref={provided.innerRef}
            style={{ minHeight: '100px', minWidth: '10rem', width: '100%' }}
          >
            {finalList.map((item, index) => (
              <DraggableSiteRouteCrew
                key={item.name + '-' + item.siteroute_id}
                index={index}
                id={`site-card-${item.siteroute_id}`}
                name={item.siteroute_name}
                draggableId={`${item.siteroute_id}`}
                color={item.hex_color}
                availableRoute={true}
                routeseats={item.routeseats}
                onToggleTransportConfig={() => {}}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    );
  }

  buildCanvassersToDisplay() {
    let assigned_canvassers = findCanvassersAssignedToShift(this.state.crews, this.state.shiftId);

    let dedupedDisplayedCanvassers = [];
    let dedupedIDCheck = [];

    this.state.displayedCanvassers &&
      this.state.displayedCanvassers.length &&
      this.state.displayedCanvassers.forEach((d) => {
        const hasAbility = d.abilities.find((a) => this.state.displayedCanvasserAbilities[a.name]);
        if (
          hasAbility ||
          (d.abilities.length == 0 && this.state.displayedCanvasserAbilities['Other'])
        ) {
          d.assigned = assigned_canvassers.includes(d.id);
          if (!dedupedIDCheck.includes(d.id)) {
            dedupedIDCheck.push(d.id);
            dedupedDisplayedCanvassers.push(d);
          }
        }
      });

    const finalList = filterAndSortItems(dedupedDisplayedCanvassers, this.state.canvasserFilters)
      .filter((d) => this.state.displayedCanvasserStatuses.includes(d.status))
      .filter((d) =>
        this.state.showAssignedCanvassers ? true : !assigned_canvassers.includes(d.id)
      );

    return finalList;
  }

  _renderScheduledCanvassers(finalList) {
    return (
      <Droppable
        droppableId="displayedCanvassers"
        style={{ minHeight: '100px', minWidth: '10rem', width: '100%' }}
      >
        {(provided) => (
          <div
            ref={provided.innerRef}
            style={{ minHeight: '100px', minWidth: '10rem', width: '100%' }}
          >
            {finalList.map((item, index) => (
              <DraggableShiftCanvasser
                key={item.lastname + '-' + item.id}
                index={index}
                id={`canvasser-card-${item.id}`}
                name={item.firstname + ' ' + item.lastname}
                canvasser={item}
                draggableId={`canvasser_${item.id}`}
                color={this.colorClassMapping[item.status].color}
                assigned={item.assigned}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    );
  }

  _renderCrews = () => {
    let hasShifts = this.state.shiftData.length > 0;

    let dropMatMessage = hasShifts
      ? 'Drag a crew over to start scheduling'
      : 'Create a shift before adding routes.';

    let crews = cloneDeep(this.state.crews).filter((crew) => crew.shift === this.state.shiftId);

    return (
      <>
        {!!this.state.crews.some((d) => d.route_to_all_sites) && (
          <div className={'crew-warning-card'}>
            <div className={'flx align_center'}>
              <i className="fas fa-exclamation-triangle fa-2x mx-5" />
              <p className={'m-0'}>
                Build your crewsheet before mobile users log in if routing to all sites.
              </p>
            </div>
          </div>
        )}

        <Droppable droppableId="crewsDrop">
          {(provided) => (
            <div ref={provided.innerRef} id="crew-drop-mat" className={`crew-drop-mat`}>
              <div className={`drop-text-wrapper ${hasShifts ? '' : 'warning'}`}>
                <div className="drop-text-plus">{hasShifts ? '+' : 'x'}</div>
                <div className="drop-text-sub">
                  {hasShifts ? 'Drag to add a route' : 'Create a shift first'}
                </div>
              </div>
              {provided.placeholder}
            </div>
          )}
        </Droppable>

        <div className={'crewlist'} id="crewlist">
          {crews.length ? (
            crews.map((item, index) => (
              <DraggableSiteRouteCrew
                ref={(ref) => {
                  if (ref) {
                    this.crewRefs[item.crew_id] = ref;
                  }
                }}
                key={`${item.siteroute_name}-${item.siteroute_id}-${item.crew_id}`}
                index={index}
                crew_id={item.crew_id}
                id={`site-card-${item.crew_id}`}
                name={item.siteroute_name}
                color={item.hex_color}
                draggableId={`crew-${item.crew_id}`}
                routeseats={item.routeseats}
                sitecanvass={this.focusedSiteCanvass}
                sr_data={item}
                availableRoute={false}
                displaySites={!this.state.hideSitesInRoutes}
                canvassers={this.props.canvassers}
                cardInDraggableContext={false}
                onCanvasserSelect={(canvasser_id, routeseat_id, crewcanvasser_id, _delete) =>
                  this._handleCanvasserSelect(
                    item.crew_id,
                    routeseat_id,
                    canvasser_id,
                    crewcanvasser_id,
                    _delete
                  )
                }
                onDeleteClick={() => this._handleDeleteCrew(item.crew_id)}
                onCrewCanvasserChange={(seat_data) =>
                  this._handleCrewCanvasserChange(item.crew_id, seat_data)
                }
                onRouteToAllSitesToggle={() => this._handleRouteToAllSitesToggle(item.crew_id)}
                office={this.state.focusedOffice}
                seatCount={item.routeseats.length}
                sites={item.routeseats.flatMap((rs) => rs.sites)}
                crewData={item}
              />
            ))
          ) : (
            <div className={`empty-drop-mat`}>{!this._isLoading() && dropMatMessage}</div>
          )}
        </div>
      </>
    );
  };

  _handleCrewCanvasserChange = (crew_id, seat_data) => {
    let crews = cloneDeep(this.state.crews);
    let crew_index = crews.findIndex((d) => d.crew_id === +crew_id);

    if (crew_index < 0) {
      console.warn('Tried to update a crew, but none found ', crew_id);
      return;
    }

    let seat_index = crews[crew_index].routeseats.findIndex(
      (d) => d.crewcanvasser_id === +seat_data.crewcanvasser_id
    );

    if (seat_index > -1) {
      crews[crew_index].routeseats[seat_index] = seat_data;
      this.setState({ crews });
    } else {
      console.warn('Could not find crewcanvasser to update: ', seat_data);
    }
  };

  _handleRouteToAllSitesToggle = (crew_id) => {
    let crews = cloneDeep(this.state.crews);
    let crew_index = crews.findIndex((d) => d.crew_id === +crew_id);

    if (crew_index < 0) {
      console.warn('Crew not found for route_to_all_sites toggle ', crew_id);
      return;
    }

    const route_to_all_sites = !crews[crew_index].route_to_all_sites;
    crews[crew_index].route_to_all_sites = route_to_all_sites;

    updateCrew(crew_id, { route_to_all_sites })
      .then(() => this.setState({ crews }))
      .catch(() => this.setError('Unable to update the crew.'));
  };

  createNewShift() {
    this.setState({ lockShiftSubmit: true });

    const data = {
      office: this.state.focusedOffice,
      start: this.state.shiftStart,
      end: this.state.shiftEnd,
      date: this.state.selectedDate,
    };

    let timeResult = this.buildStrictTimeString(data);

    if (!timeResult.strictStart || !timeResult.strictEnd) {
      this.setState({ invalidInput: true, lockShiftSubmit: false });
      return;
    }

    if (!this.checkValidRange(timeResult.strictStart, timeResult.strictEnd)) {
      this.setState({ invalidTime: true, lockShiftSubmit: false });
      return;
    }

    data.start = timeResult.strictStart;
    data.end = timeResult.strictEnd;

    createShift(data).then((data) => {
      if (data) {
        let shifts = [...this.state.shiftData, data];
        this.props.setCrewsShiftData(data);

        this.setState({
          shiftData: shifts,
          shiftSuccess: true,
          showShiftModal: false,
          lockShiftSubmit: false,
          shiftId: data.id,
        });

        setTimeout(() => this.setState({ shiftSuccess: false }), 6000);
      } else {
        this.setState({
          shiftError: true,
          showShiftModal: false,
          lockShiftSubmit: false,
        });

        setTimeout(() => this.setState({ shiftError: false }), 6000);
      }
    });
  }

  buildStrictTimeString(data) {
    const convertToAmPm = (hhmm) => {
      if (!hhmm || !hhmm.includes(':')) return null;
      let [h, m] = hhmm.split(':').map(Number);

      const ampm = h >= 12 ? 'pm' : 'am';
      let hour12 = h % 12;
      if (hour12 === 0) hour12 = 12;

      return `${hour12}:${m.toString().padStart(2, '0')}${ampm}`;
    };

    const strictStart = convertToAmPm(data.start);
    const strictEnd = convertToAmPm(data.end);

    return { strictStart, strictEnd };
  }

  checkValidRange(start, end) {
    return Moment(start, 'h:mma').isBefore(Moment(end, 'h:mma'));
  }

  _validateDateTime(data) {
    let valid = false;
    let validRange = false;
    let strictStart, strictEnd;

    const clean = (s) => s.replace(/\s/g, '').toLowerCase();
    if (!data.start || !data.end) {
      this.setState({ invalidInput: true });
      return { valid };
    }

    const _start = clean(data.start);
    const _end = clean(data.end);

    valid = Moment(_start, 'LT', true).isValid();
    valid = Moment(_end, 'LT', true).isValid();
    validRange = Moment(_start, 'LT').isBefore(Moment(_end, 'LT'));

    if (!valid) {
      this.setState({ invalidInput: true });
      return { valid: false };
    }

    if (!validRange) {
      this.setState({ invalidTime: true });
      return { valid: false };
    }

    let startPieces = _start.match(/^0*(0?[1-9]|1[012]):([0-5]\d)\d*([ap]m)$/);
    let endPieces = _end.match(/^0*(0?[1-9]|1[012]):([0-5]\d)\d*([ap]m)$/);

    if (startPieces && endPieces) {
      strictStart = startPieces[1] + ':' + startPieces[2] + startPieces[3];
      strictEnd = endPieces[1] + ':' + endPieces[2] + endPieces[3];
    } else {
      this.setState({ invalidInput: true });
      return { valid: false };
    }

    return { valid: true, strictStart, strictEnd };
  }

  _handleTimeChange(key, val) {
    this.setState({
      [key]: val.trim(),
      invalidInput: false,
      invalidTime: false,
    });
  }

  _renderCreateShiftModal() {
    return (
      <BaseModal
        open={this.state.showShiftModal}
        onClose={() => this.setState({ showShiftModal: false })}
        center
      >
        <div className="container">
          <i
            className="fas fa-pull-right fa-times"
            style={{ cursor: 'pointer' }}
            onClick={() => this.setState({ showShiftModal: false })}
          />
          <h4 className={'primary-text'}>
            Create A Shift <span style={{ fontSize: '.7em' }}>({this.state.selectedDate})</span>
          </h4>

          {/* START TIME */}
          <span className={'secondary-text'}>Start Time</span>
          <Input
            type="time"
            step="900" // 15-minute increments
            onChange={this._handleTimeChange.bind(this, 'shiftStart')}
            value={this.state.shiftStart || ''}
          />

          {/* END TIME */}
          <span className={'secondary-text'}>End Time</span>
          <Input
            type="time"
            step="900"
            onChange={this._handleTimeChange.bind(this, 'shiftEnd')}
            value={this.state.shiftEnd || ''}
          />

          {/* ERROR MESSAGES */}
          {this.state.invalidInput && (
            <div className="danger-text" style={{ fontWeight: 'bold' }}>
              Invalid Date / Time
            </div>
          )}
          {this.state.invalidTime && (
            <div className="danger-text" style={{ fontWeight: 'bold' }}>
              End must be after start time
            </div>
          )}

          {/* SUBMIT BUTTON */}
          <button
            disabled={!this.state.shiftStart || !this.state.shiftEnd || this.state.lockShiftSubmit}
            className="button button-outline text-primary"
            onClick={this.createNewShift.bind(this)}
          >
            Submit
          </button>
        </div>
      </BaseModal>
    );
  }

  flattenAbilities = () => {
    let avail = { Other: true };
    this.props.canvassers.forEach((c) => {
      if (c.abilities) {
        c.abilities.forEach((a) => (avail[a.name] = true));
      }
    });
    return avail;
  };

  _handleOfficeChange = (val) => {
    this.setState({ focusedOffice: +val }, this.getAndParseSchedule);
  };

  _handleShiftChange(val) {
    const shiftDataIndex = this.state.shiftData.findIndex((d) => d.id === +val);
    let shiftData = shiftDataIndex > -1 ? this.state.shiftData[shiftDataIndex] : {};
    this.props.setCrewsShiftData(shiftData);

    this.setState({
      crewsheet_selected_shift_idx: shiftDataIndex,
      shiftId: +val,
    });
  }

  _loadCrewSheetModal = () => {
    this.props.setSessionVar('excludedCrews', []);
    this.props.setSessionVar('hideDrivingDirections', false);
    this.props.setSessionVar('hideTravelPaths', false);

    this.setState({
      crewsheet_modal_show: true,
      crewsheet_crews: this.state.crews.map((d) => d.crew_id),
    });
  };

  _handlePrintCrewSheetsRequest = () => {
    window.open(`/crewsheet/${this.props.shift_data.id}`, '_blank');
  };

  _changeDate = (forward) => {
    // Disable the UI momentarily if needed
    this.setState({ loading: true });

    clearTimeout(this.dateChangeTimeout);

    this.dateChangeTimeout = setTimeout(() => {
      let cur = new Moment(this.state.selectedDate);

      let next = forward ? cur.add(1, 'days') : cur.subtract(1, 'days');

      this.setState(
        {
          selectedDate: next.format('YYYY-MM-DD'),
        },
        () => this.getDataOnLoad()
      );
    }, 300);
  };

  _buildCrewSheetModal = () => {
    return (
      <BaseModal
        open={this.state.crewsheet_modal_show}
        onClose={() => this.setState({ crewsheet_modal_show: false })}
        center
      >
        <div className="container">
          <i
            className="fas fa-pull-right fa-times"
            style={{ cursor: 'pointer' }}
            onClick={() => this.setState({ crewsheet_modal_show: false })}
          />
          <h4 className="primary-text">Crew Sheet Options</h4>

          <p>Select which crews to include:</p>

          <div className="crew-checkbox-list">
            {this.state.crews.map((crew) => (
              <label key={crew.crew_id} style={{ display: 'block' }}>
                <input
                  type="checkbox"
                  checked={this.state.crewsheet_crews.includes(crew.crew_id)}
                  onChange={(ev) => {
                    let updated = [...this.state.crewsheet_crews];
                    if (ev.target.checked) updated.push(crew.crew_id);
                    else updated = updated.filter((id) => id !== crew.crew_id);

                    this.setState({ crewsheet_crews: updated });
                  }}
                />
                Crew #{crew.crew_id}: {crew.siteroute_name}
              </label>
            ))}
          </div>

          <button
            className="button button-outline text-primary"
            onClick={this._handlePrintCrewSheetsRequest}
          >
            Print Crew Sheets
          </button>
        </div>
      </BaseModal>
    );
  };

  _isLoading = () => {
    return (
      (this.props.siteroutes_loading || this.props.canvassers_loading || this.state.loading) &&
      !this._isError()
    );
  };

  _isError = () => {
    return (
      this.props.canvassers_error ||
      this.props.siteroutes_error ||
      this.state.shiftError ||
      this.state.pageError
    );
  };

  render() {
    let shiftCrews = this.state.shiftId
      ? this.state.crews.filter((crew) => crew.shift === this.state.shiftId)
      : this.state.crews;

    let routeValue =
      this.state.routeFilters.keywordPersist !== ''
        ? { value: this.state.routeFilters.keyword }
        : {};

    let canvasserValue =
      this.state.canvasserFilters.keywordPersist !== ''
        ? { value: this.state.canvasserFilters.keyword }
        : {};

    const debouncedCanvasserSearch = debounce((query) => {
      const [baseState, keyword] = handleSearchChange(query);
      this.setState(
        {
          ...baseState,
          canvasserFilters: {
            ...this.state.canvasserFilters,
            keyword,
          },
        },
        () => filterAndSortItems(this.props.canvassers, this.state.canvasserFilters)
      );
    }, 300);

    const debouncedRouteSearch = debounce((query) => {
      const [baseState, keyword] = handleSearchChange(query);
      this.setState(
        {
          ...baseState,
          routeFilters: {
            ...this.state.routeFilters,
            keyword,
          },
        },
        () => filterAndSortItems(this.state.siteRoutes, this.state.routeFilters)
      );
    }, 300);

    const finalList =
      this.state.sideBarSelection === 'siteroutes'
        ? this.buildRoutesToDisplay()
        : this.buildCanvassersToDisplay();

    return (
      <NavBaseTemplate disabled={true}>
        <div className="schedule-page">
          <SiteNoteModal showCloseIcon center />
          <DragDropContext onDragEnd={this.onDragEnd}>
            <div className="flx space_between align_base schedule-title-flex">
              <h3 className="primary-text">Schedule Crews</h3>
              <div>
                <button
                  className={`button button-outline text-primary ${
                    shiftCrews.length ? '' : 'disabled'
                  }`}
                  onClick={this._loadCrewSheetModal}
                >
                  Build Crew Sheets
                </button>

                <button
                  style={{
                    marginLeft: '1em',
                    color: '#2F96B4',
                    borderColor: '#2F96B4',
                  }}
                  className="button button-outline text-primary"
                  onClick={() => this.setState({ showShiftModal: true })}
                >
                  Create A Shift
                </button>
              </div>
            </div>

            <div className="row">
              {/* LEFT COLUMN */}
              <div className="column column-80">
                <div className="flx space_between schedule-options-flex">
                  <div className="flx justify-start date-select-line">
                    <i
                      className="fas fa-caret-left"
                      onClick={() => this._changeDate(false)}
                      title="Previous Day"
                    />
                    <h5 style={{ fontFamily: 'Arial' }}>{this.state.selectedDate}</h5>
                    <i
                      className="fas fa-caret-right"
                      title="Next Day"
                      onClick={() => this._changeDate(true)}
                    />
                  </div>

                  <div className="flx justify-end">
                    <div className="override-milligram scheduler-drop-down">
                      {this.state.shiftData.length > 0 && (
                        <>
                          <div className="mr-3">Shift</div>
                          <Input
                            type={'select'}
                            style={{ minWidth: '180px' }}
                            value={this.props.shift_data.id}
                            options={this.state.shiftData.map((d) => ({
                              value: d.id,
                              display:
                                new Moment(`${d.shift_date} ${d.start_time}`).format('LT') +
                                ' - ' +
                                new Moment(`${d.shift_date} ${d.end_time}`).format('LT'),
                            }))}
                            onChange={(val) => this._handleShiftChange(val)}
                          />
                        </>
                      )}
                    </div>

                    <div className="override-milligram scheduler-drop-down">
                      <div className="mr-3">Office</div>
                      <Input
                        type={'select'}
                        style={{ minWidth: '180px' }}
                        value={this.state.focusedOffice}
                        options={this.props.offices.map((d) => ({
                          value: d.id,
                          display: d.name,
                        }))}
                        onChange={(val) => this._handleOfficeChange(val)}
                      />
                    </div>
                  </div>
                </div>

                <div className="card wox-card crews-card">{this._renderCrews()}</div>
              </div>

              {/* RIGHT COLUMN */}
              <div className="column column-20 schedule-right-column">
                <Tabs
                  tabs={[
                    {
                      display: (
                        <span className="tab-label">
                          <i style={{ padding: '0 0.5em 0 1em' }} className="fas fa-route" />
                          Routes
                        </span>
                      ),
                      onClick: () =>
                        this.setState({
                          sideBarSelection: 'siteroutes',
                          routeFilters: {
                            ...this.state.routeFilters,
                            keywordPersist: this.state.routeFilters.keyword,
                          },
                        }),
                      active: this.state.sideBarSelection === 'siteroutes',
                    },
                    {
                      display: (
                        <span className="tab-label">
                          <i style={{ padding: '0 0.5em 0 1em' }} className="fas fa-user-clock" />
                          Canvassers
                        </span>
                      ),
                      onClick: () =>
                        this.setState({
                          sideBarSelection: 'canvassers',
                          canvasserFilters: {
                            ...this.state.canvasserFilters,
                            keywordPersist: this.state.canvasserFilters.keyword,
                          },
                        }),
                      active: this.state.sideBarSelection === 'canvassers',
                    },
                  ]}
                  style={{
                    marginBottom: '.8em',
                    justifyContent: 'center',
                  }}
                />

                <div className="card wox-card crews-card assigned-canvasser-counter primary-text">
                  <div>
                    {findCanvassersAssignedToShift(this.state.crews, this.state.shiftId).length}{' '}
                    Canvassers assigned
                  </div>
                  {Moment(this.state.selectedDate).isSame(Date.now(), 'day') && (
                    <div>
                      {findCheckedInCanvassers(this.state.displayedCanvassers).length} Checked in
                    </div>
                  )}
                </div>

                <div className="card wox-card crews-card" style={{ padding: '4px 8px' }}>
                  <div className="sidebar-wrapper">
                    {this.state.sideBarSelection === 'siteroutes' && (
                      <FilterDisplay
                        filters={this.state.routeFilters}
                        hideModalButton
                        handleSearchChange={(val) => debouncedRouteSearch(val)}
                        handleSortUpdate={(val) =>
                          this.setState({
                            routeFilters: {
                              ...this.state.routeFilters,
                              sortBy: val,
                            },
                          })
                        }
                        handleSortDirectionChange={() =>
                          this.setState({
                            routeFilters: {
                              ...this.state.routeFilters,
                              sortDsc: !this.state.routeFilters.sortDsc,
                            },
                          })
                        }
                        value={routeValue}
                      />
                    )}

                    {this.state.sideBarSelection === 'canvassers' && (
                      <>
                        <CanvasserFilters
                          totalCount={finalList.length}
                          availableAbilities={this.flattenAbilities()}
                          handleFilterUpdate={(statuses, abilities, assigned) => {
                            this.setState({
                              displayedCanvasserStatuses: statuses,
                              displayedCanvasserAbilities: abilities,
                              showAssignedCanvassers: assigned,
                            });
                          }}
                        />

                        <FilterDisplay
                          filters={this.state.canvasserFilters}
                          hideModalButton={true}
                          inlineFilters={finalList}
                          handleSearchChange={(val) => debouncedCanvasserSearch(val)}
                          handleSortUpdate={(val) =>
                            this.setState({
                              canvasserFilters: {
                                ...this.state.canvasserFilters,
                                sortBy: val,
                              },
                            })
                          }
                          handleSortDirectionChange={() =>
                            this.setState({
                              canvasserFilters: {
                                ...this.state.canvasserFilters,
                                sortDsc: !this.state.canvasserFilters.sortDsc,
                              },
                            })
                          }
                          value={canvasserValue}
                        />
                        <span style={{ float: 'right', fontSize: 11 }}>
                          {finalList.length} canvassers
                        </span>
                      </>
                    )}

                    {this.state.sideBarSelection === 'siteroutes'
                      ? this._renderUnassignedRoutes(finalList)
                      : this._renderScheduledCanvassers(finalList)}
                  </div>
                </div>
              </div>
            </div>
          </DragDropContext>

          {this.state.crewsheet_modal_show && this._buildCrewSheetModal()}
          {this._renderCreateShiftModal()}

          <FeedbackTile
            text={
              <div>
                <i className="fas fa-asterisk fa-spin" style={{ marginRight: 15 }} />
                Loading...
              </div>
            }
            visible={this._isLoading()}
          />

          <FeedbackTile
            text={
              <div>
                <i className="fas fa-check" style={{ marginRight: 15 }}></i>
                Shift Created
              </div>
            }
            visible={this.state.shiftSuccess}
          />

          <FeedbackTile
            text={
              <div>
                <i className="fas fa-exclamation-triangle" style={{ marginRight: 15 }} />
                {this.state.errMsg}
              </div>
            }
            visible={this._isError()}
            classNames="danger"
          />
        </div>
      </NavBaseTemplate>
    );
  }
} // end class

const mapStateToProps = (state) => ({
  focusedCampaign: state.session.focusedCampaign,
  siteCanvasses: state.siteCanvasses.data,
  siteRoutes: state.siteRoutes.data,
  siteroutes_loading: state.siteRoutes.loading,
  siteroutes_error: state.siteRoutes.error,
  canvassers: state.canvassers.data,
  canvassers_loading: state.canvassers.loading,
  canvassers_error: state.canvassers.error,
  is_admin: state.permissions.is_admin,
  shift_data: state.crews.shift_data,
  sessionVars: state.session.vars,
  offices: state.offices.data,
});

const mapDispatchToProps = (dispatch) => ({
  setCrewsForRouting: (crews) => dispatch(setCrews(crews)),
  setCrewsShiftData: (data) => dispatch(setCrewsShiftData(data)),
  setSessionVar: (key, value) => dispatch(setSessionVar(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Schedule));
